import React from 'react'
import Helmet from 'react-helmet'

import { CONFIG } from '../config'

import Template from '../components/layout'
import AppLink from '../components/AppLink'
import header from './404-images/blog-404-header.svg'

import simMobile from './404-images/blog-404-sim-mobile.png'
import worldMobile from './404-images/blog-404-world-mobile.png'
import yeahMobile from './404-images/blog-404-blog-mobile.png'

import simDesktop from './404-images/blog-404-plans-desktop.png'
import worldDesktop from './404-images/blog-404-dashboard-desktop.png'
import yeahDesktop from './404-images/blog-404-blog-desktop.png'

import * as styles from './index.module.scss'

const ErrorPage = () => (
  <Template>
    <Helmet>
      <title>Error 404 Page Not Found</title>
      <link
        rel="shortcut icon"
        sizes="16x16 32x32"
        type="image/png"
        href={`${CONFIG.MARKETING_URL}favicon.png`}
      ></link>
      <link
        rel="apple-touch-icon"
        href={`${CONFIG.MARKETING_URL}apple-touch-icon.png`}
      />
      <link
        rel="sitemap"
        type="application/xml"
        href={`${CONFIG.MARKETING_URL}sitemap.xml`}
      />
    </Helmet>

    <div className={styles.Four04} role="main">
      <img src={header} alt="" />
      <h1>Oops, page not found</h1>
      <p className={styles.showDesktop}>
        The page you are looking for doesn&apos;t exist
        <br />
        or has been moved.
      </p>
      <p className={styles.showMobile}>
        The page you are looking for
        <br />
        doesn&apos;t exist or has been moved.
      </p>
      <div className={styles.MainPages}>
        <h2>Our main pages</h2>
        <div className={styles.MainPagesLinks}>
          <AppLink
            className={styles.MainPagesLink}
            link={`${CONFIG.MARKETING_URL}all-plans`}
            showMobile={styles.showMobile}
            showDesktop={styles.showDesktop}
            srcMobile={simMobile}
            srcDesktop={simDesktop}
            title="Plans"
          />
          <AppLink
            className={styles.MainPagesLink}
            link={`${CONFIG.DASHBOARD_URL}`}
            showMobile={styles.showMobile}
            showDesktop={styles.showDesktop}
            srcMobile={worldMobile}
            srcDesktop={worldDesktop}
            title="Dashboard"
          />
          <AppLink
            className={styles.MainPagesLink}
            link={`${CONFIG.BLOG_URL}`}
            showMobile={styles.showMobile}
            showDesktop={styles.showDesktop}
            srcMobile={yeahMobile}
            srcDesktop={yeahDesktop}
            title="Blog"
          />
        </div>
      </div>
    </div>
  </Template>
)

export default ErrorPage
